import type { IconNode } from '../types';

/**
 * @name intercom
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHg9IjIiIHk9IjIiIHJ4PSIyIiAvPgogIDxwYXRoIGQ9Ik02IDl2NiIgLz4KICA8cGF0aCBkPSJNMTAgNnYxMiIgLz4KICA8cGF0aCBkPSJNMTQgNnYxMiIgLz4KICA8cGF0aCBkPSJNMTggOXY2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/intercom
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const intercom: IconNode = [
  ['rect', { width: '20', height: '20', x: '2', y: '2', rx: '2', key: '1btzen' }],
  ['path', { d: 'M6 9v6', key: 'rxvg2g' }],
  ['path', { d: 'M10 6v12', key: '1xqmlc' }],
  ['path', { d: 'M14 6v12', key: '7odqp' }],
  ['path', { d: 'M18 9v6', key: '1twb98' }],
];

export default intercom;
